import _styled from "@emotion/styled-base";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import { css } from "@emotion/core";
import { emRhythm, hideFocusRingOnClick } from "../css";
import { forwardInnerRef } from "../utils";
import { AlertContext } from "./Alert";
import { getHoverBackgroundColor } from "./AlertLink";

var StyledAlertCloseButton = /*#__PURE__*/_styled("button", {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "tier" && prop !== "subtle";
  },
  target: "e1hsnzvg0"
})(function (props) {
  return /*#__PURE__*/css("label:base;display:flex;align-items:center;justify-content:center;flex:0 0 auto;width:1em;height:1em;margin-left:", emRhythm(0.25), ";padding:0;background:transparent;color:inherit;border:0;cursor:pointer;position:relative;top:0.2em;&::before{display:block;content:\" \";position:absolute;width:1.5em;height:1.5em;top:-0.25em;left:-0.25em;border-radius:100%;transition:all 120ms ease-in-out;background:trasnparent;z-index:1;transform:scale(0);}svg{position:relative;z-index:2;}&:hover{color:", props.subtle ? props.theme.colors.heading : "currentColor", ";&::before{background:", getHoverBackgroundColor(props), ";transform:scale(1);}}");
}, function (_ref) {
  var subtle = _ref.subtle;
  return subtle || /*#__PURE__*/css("label:is-subtle;margin-right:", emRhythm(-0.25), ";");
}, hideFocusRingOnClick);

function AlertCloseButton(_ref2) {
  var innerRef = _ref2.innerRef,
      props = _objectWithoutPropertiesLoose(_ref2, ["innerRef"]);

  var alertValues = React.useContext(AlertContext);
  return ___EmotionJSX(StyledAlertCloseButton, _extends({
    ref: innerRef
  }, props, alertValues));
}

export default forwardInnerRef(AlertCloseButton);